import * as React from "react";
import Layout from "../components/layout";

const Exposicions = () => {
  const [isMobile, setIsMobile] = React.useState(true);

  React.useEffect(() => {
    window.innerWidth > 600 ? setIsMobile(false) : setIsMobile(true);
  }, []);

  return (
    <Layout
      title="Cos Paisatge, properes exposicions"
      description="Vallgrassa, Centre Experimental de les Arts, Garraf, març i abril de 2022. Museu de la Mediterrania, Torroella de Montrgí, agost de 2022. Treseu, galeria fotogràfica, Vic, novembre de 2022"
      path="/exposicions"
    >
      <>
        <h2>Properes exposicions</h2>

        <div className="properaExpo">
          <a href="#vallgrassa">
            <div className="dataExpo past">
              <span>2022 març, abril</span>
            </div>
          </a>

          <a href="#vallgrassa">
            <div className="listExpo">
              <span>Vallgrassa, Centre Experimental de les Arts</span>
            </div>
          </a>

          <a href="#mediterrania">
            <div className="dataExpo past">
              <span> 2022 agost</span>
            </div>
          </a>

          <a href="#mediterrania">
            <div className="listExpo">
              <span className="listExpo">Museu de la Mediterrania</span>
            </div>
          </a>

          <a href="#treseu">
            <div className="dataExpo">
              <span> 2022 novembre</span>
            </div>
          </a>
          <a href="#treseu">
            <div className="listExpo">
              <span>Treseu, galeria fotogràfica</span>
            </div>
          </a>
        </div>
        <div className="expoCard">
          <h3 id="treseu">Treseu, galeria fotogràfica</h3>
          <p>
            <strong>Dates</strong>: Del 3 al 30 de Novembre de 2022
          </p>
          <p>
            <strong>Inauguració</strong>: Divendres 3 de Novembre a les 19h.
          </p>
          <p>
            <strong>Horari</strong>: dimarts, dijous i dissabte de 10 a 13h.
            Dilluns, dimecres i divendres, de 17 a 20h.
          </p>
          <p>
            <strong>Telèfon</strong>: <a href="tel:609527108">609 527 108</a>
          </p>

          <p>
            <strong>Web</strong>:{" "}
            <a href="https://www.treseu.cat/">www.treseu.cat</a>
          </p>
          <p>
            <strong>Adreça</strong>: Carrer del Pont 10 (Plaça Gaudí). 08500,
            Vic
          </p>
          <iframe
            title="treseu"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2968.351097868377!2d2.250681551700301!3d41.92830637014668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a5271ab1550001%3A0x5abca48953c3e6ce!2sTres-e-u%20galeria%20fotogr%C3%A0fica!5e0!3m2!1sen!2ses!4v1643710371377!5m2!1sen!2ses"
            width={isMobile ? 340 : 450}
            height={300}
            style={{ border: 0 }}
            allowfullscreen={""}
            loading={"lazy"}
          ></iframe>
        </div>
        <div className="expoCard">
          <h3 id="vallgrassa">Vallgrassa, Centre Experimental de les Arts</h3>

          <p>
            <strong>Dates</strong>: del 20 de març a l'1 de maig de 2022
          </p>
          <p>
            <strong>Inauguració</strong>: diumenge 3 d'abril, 12h
          </p>
          <p>
            <strong>Horari</strong>: divendres, dissabtes i diumenges de 10 a
            14h
          </p>
          <p>
            <strong>Telèfon</strong>: <a href="tel:937440656">937 440 656</a>
          </p>
          <p>
            <strong>Web</strong>:{" "}
            <a href="https://www.vallgrassa.cat/">vallgrassa.cat</a>
          </p>
          <p>
            <strong>Adreça</strong>: Carretera de Rat Penat a Plana Novella, km
            6,5 08859 Begues
          </p>
          <iframe
            title="vallgrassa"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.2015057409094!2d1.8740889524997089!3d41.282718732560355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x54710e97fec7fe5e!2sVallgrassa.Centre%20Experimental%20de%20les%20Arts!5e0!3m2!1sen!2ses!4v1643545129139!5m2!1sen!2ses"
            width={isMobile ? 340 : 450}
            height={300}
            style={{ border: 0 }}
            allowfullscreen={""}
            loading={"lazy"}
          ></iframe>
        </div>

        <div className="expoCard">
          <h3 id="mediterrania">Museu de la Mediterrania</h3>
          <p>
            <strong>Dates</strong>: Agost de 2022
          </p>
          <p>
            <strong>Horari</strong>: de dilluns a dissabte, de 10 h a 14 h i de
            17.30 h a 21 h
          </p>
          <p>
            <strong>Telèfon</strong>: <a href="tel:972755180">972 755 180</a>
          </p>

          <p>
            <strong>Web</strong>:{" "}
            <a href="https://www.museudelamediterrania.cat/">
              www.museudelamediterrania.cat
            </a>
          </p>
          <p>
            <strong>Adreça</strong>: Carrer d'Ullà, 27-31 17257 Torroella de
            Montgrí
          </p>
          <iframe
            title="mediterrania"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d185.19336586436953!2d3.124439996374667!3d42.041167747706844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ba58242516a475%3A0x8a93635db2bdd75f!2sMuseu%20de%20la%20Mediterr%C3%A0nia!5e0!3m2!1sen!2ses!4v1643710201401!5m2!1sen!2ses"
            width={isMobile ? 340 : 450}
            height={300}
            style={{ border: 0 }}
            allowfullscreen={""}
            loading={"lazy"}
          ></iframe>
        </div>
      </>
    </Layout>
  );
};

export default Exposicions;
